import { render } from "./HouseholdManagement.vue?vue&type=template&id=0bde4da4&scoped=true"
import script from "./HouseholdManagement.vue?vue&type=script&lang=js"
export * from "./HouseholdManagement.vue?vue&type=script&lang=js"

import "./HouseholdManagement.vue?vue&type=style&index=0&id=0bde4da4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bde4da4"]])

export default __exports__